<template>
  <div>
    <v-dialog persistent v-model="dialog" width="900">
      <v-card>
        <v-card-title>
          <span class="headline">Gestion des natures</span>
        </v-card-title>
        <v-card-text class="mt-2">
          <v-btn small color="primary" @click="addRow">Ajouter une ligne</v-btn>
          <v-data-table :headers="headers" :items="localTOBudgets" hide-default-footer>
            <template v-slot:[`item.action`]="{ item }">
              <v-btn v-if="localTOBudgets.indexOf(item) !== 0" small @click="deleteRow(item)">Supprimer</v-btn>
            </template>
            <template v-slot:[`item.code_nature`]="{ item }">
              <v-autocomplete
                v-model="item.code_nature"
                :items="TO_AnalyticNatureList"
                :item-text="item => item.libelle_nature + ' - ' + item.natureAnalytique"
                item-value="natureAnalytique"
                @change="onChangeNature(item)"
                style="font-size: 14px; width: 350px;"
                required
                dense
              ></v-autocomplete>
            </template>
            <template v-slot:[`item.montant`]="{ item }">
              <v-text-field v-model="item.montant" type="number" @input="onChangeAmount(item)" @blur="filterAmount(item)" style="font-size: 14px;" required dense></v-text-field>
            </template>
            <template v-slot:[`item.montant_budget`]="{ item }">
              <div>{{ item.montant_budget | deuxDecimales }}</div>
            </template>
            <template v-slot:[`item.montant_restant_budget`]="{ item }">
              <div>{{ item.montant_restant_budget | deuxDecimales }}</div>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-row justify="end">
            <v-col cols="12" sm="6">
              <v-card class="mt-4">
                <v-card-text>
                  <div class="subtitle-1">Montant total engagé : {{ calculateTotalMontant() | deuxDecimales }}</div>
                  <div class="subtitle-1">Budget total : {{ calculateTotalMontantBudget() | deuxDecimales }}</div>
                  <div class="subtitle-1">Restant budget total : {{ calculateTotalMontantRestantBudget() | deuxDecimales }}</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Annuler</v-btn>
          <v-btn color="blue darken-1" text @click="saveAndClose" :disabled="!valid || !ready">Sauvegarder</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    L_EngageID: Number,
    R_MontantTotal: Number,
    TO_budgets: Array,
    TO_AnalyticNatureList: Array
  },
  filters: {
    deuxDecimales(value) {
      return parseFloat(value).toFixed(2);
    }
  },
  computed: {
    valid: function() {
      return this.R_MontantTotal == 0 || this.R_MontantTotal == this.calculateTotalMontant();
    }
  },
  data() {
    return {
      dialog: false,
      ready: true,
      localTOBudgets: [], // cloner les données TO_budgets localement
      debounceTimer: null,
      headers: [
        { text: "Nature Analytique", value: "code_nature", sortable: false },
        { text: "Montant engagé", value: "montant", sortable: false },
        { text: "Montant budget", value: "montant_budget", align: "right", sortable: false },
        { text: "Restant budget", value: "montant_restant_budget", align: "right", sortable: false },
        { text: "", value: "action", sortable: false }
      ]
    };
  },
  methods: {
    calculateTotalMontant() {
      let total = 0;
      for (const item of this.localTOBudgets) {
        total += parseFloat(item.montant || 0);
      }
      return total;
    },
    calculateTotalMontantBudget() {
      let total = 0;
      for (const item of this.localTOBudgets) {
        total += parseFloat(item.montant_budget || 0);
      }
      return total;
    },
    calculateTotalMontantRestantBudget() {
      let total = 0;
      for (const item of this.localTOBudgets) {
        total += parseFloat(item.montant_restant_budget || 0);
      }
      return total;
    },
    show() {
      this.localTOBudgets = JSON.parse(JSON.stringify(this.TO_budgets));
      this.dialog = true;
    },
    saveAndClose() {
      this.$emit("update:TO_budgets", this.localTOBudgets);
      this.dialog = false;
    },
    addRow() {
      this.localTOBudgets.push({
        fk_engagement: this.L_EngageID,
        fk_budget: 0,
        fk_NatureAnalytique: 0,
        code_nature: "",
        montant: 0,
        montant_budget: 0,
        montant_restant_budget: 0,
        engagements_count_budget: 0,
        engagements_pk_budget: []
      });
    },
    deleteRow(item) {
      var index = this.localTOBudgets.indexOf(item);
      if (index !== -1) {
        this.localTOBudgets.splice(index, 1);
      }
    },
    onChangeNature(item) {
      const self = this;
      this.ready = false;
      var index = this.localTOBudgets.indexOf(item);
      if (index !== -1) {
        var selected_nature = this.TO_AnalyticNatureList.find(nature => nature.natureAnalytique === item.code_nature);
        if (selected_nature) {
          item.fk_budget = selected_nature.id;
          item.fk_NatureAnalytique = selected_nature.fk_NatureAnalytique;
        } else {
          item.fk_budget = 0;
          item.fk_NatureAnalytique = 0;
          item.code_nature = "";
        }
        this.updateItemTotals(item).then(function() {
          self.ready = true;
        });
      }
    },
    onChangeAmount(item) {
      const self = this;
      this.ready = false;
      var index = this.localTOBudgets.indexOf(item);
      if (index !== -1) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          this.updateItemTotals(item).then(function() {
            self.ready = true;
          });
        }, 500);
      }
    },
    filterAmount(item) {
      this.ready = false;
      var index = this.localTOBudgets.indexOf(item);
      if (index !== -1) {
        item.montant = item.montant.replace(",", ".");
        item.montant = parseFloat(item.montant).toFixed(2);
        this.ready = true;
      }
    },
    updateItemTotals(item) {
      item.montant_budget = 0;
      item.montant_restant_budget = 0;
      item.montant_restant_budget_tmp = 0;
      item.engagements_count_budget = 0;
      item.engagements_pk_budget = [];

      if (item.fk_budget > 0) {
        var data = {};
        if (this.L_EngageID > 0) {
          data.excludeEngagements = [this.L_EngageID];
        }

        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .post("budget/" + item.fk_budget + "/totals/", data, { headers: { Authorization: T_Token } })
          .then(response => {
            item.montant_budget = response.data.montant_budget.toFixed(2);
            item.montant_restant_budget = (response.data.montant_restant_budget - item.montant).toFixed(2);
            item.montant_restant_budget_tmp = response.data.montant_restant_budget.toFixed(2);
            item.engagements_count_budget = response.data.engagements_count_budget;
            item.engagements_pk_budget = response.data.engagements_pk_budget;
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    }
  }
};
</script>

<style scoped></style>
